import type { AppContext, ViewCleanup } from "../app";
import type { ArcadeMode } from "../state/types";
import { mountArcadeSpeedRun } from "./arcade-speed-run";
import { mountArcadeSurvival } from "./arcade-survival";
import { mountArcadeReverse } from "./arcade-reverse";

// Thin dispatcher — the router's data-attr plumbing carries `mode` and
// `region` in via root.dataset, and we pick the right view based on mode.

export const mountArcadeMode = (
  root: HTMLElement,
  ctx: AppContext,
): ViewCleanup | Promise<ViewCleanup> => {
  const mode = root.dataset.mode as ArcadeMode | undefined;
  if (!mode) {
    ctx.nav.goArcade();
    return () => {};
  }
  switch (mode) {
    case "speed-run":
      return mountArcadeSpeedRun(root, ctx);
    case "survival":
      return mountArcadeSurvival(root, ctx);
    case "reverse":
      return mountArcadeReverse(root, ctx);
    default:
      ctx.nav.goArcade();
      return () => {};
  }
};
